import React, { useState } from 'react';

const ContactTable = ({ datas }) => {
    const [search, setSearch] = useState('');
    const [expanded, setExpanded] = useState(null);

    const filtered = datas.filter(c =>
        (c.fname || '').toLowerCase().includes(search.toLowerCase()) ||
        (c.lname || '').toLowerCase().includes(search.toLowerCase()) ||
        (c.email || '').toLowerCase().includes(search.toLowerCase()) ||
        (c.msg || '').toLowerCase().includes(search.toLowerCase())
    );

    function formatDate(date) {
        if (!date) return '—';
        return new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    }

    return (
        <div>
            <div className='flex items-center justify-between mb-4'>
                <div>
                    <input
                        className='border border-gray-300 rounded-lg px-3 py-2 text-sm w-72'
                        placeholder='Search contacts...'
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                    <span className='ml-3 text-sm text-gray-400'>{filtered.length} messages</span>
                </div>
            </div>

            {filtered.length === 0 ? (
                <div className='bg-white rounded-lg border border-gray-200 p-12 text-center'>
                    <p className='text-gray-400'>No contact messages</p>
                </div>
            ) : (
                <div className='space-y-3'>
                    {filtered.map(contact => (
                        <div key={contact._id} className='bg-white rounded-lg border border-gray-200 overflow-hidden'>
                            <div
                                className='flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-gray-50 transition-colors'
                                onClick={() => setExpanded(expanded === contact._id ? null : contact._id)}
                            >
                                <div className='flex items-center gap-4'>
                                    <div className='w-9 h-9 bg-pink-100 text-pink-700 rounded-full flex items-center justify-center font-bold text-sm'>
                                        {(contact.fname || '?').charAt(0).toUpperCase()}
                                    </div>
                                    <div>
                                        <p className='text-sm font-medium'>{contact.fname} {contact.lname}</p>
                                        <p className='text-xs text-gray-400'>{contact.email}{contact.phone ? ` · ${contact.phone}` : ''}</p>
                                    </div>
                                </div>
                                <div className='flex items-center gap-3'>
                                    <span className='text-xs text-gray-400'>{formatDate(contact.date)}</span>
                                    <span className='text-gray-400'>{expanded === contact._id ? '−' : '+'}</span>
                                </div>
                            </div>
                            {expanded === contact._id && (
                                <div className='px-5 pb-4 border-t border-gray-100 pt-3'>
                                    <p className='text-sm text-gray-700 whitespace-pre-wrap'>{contact.msg || 'No message'}</p>
                                    {contact.email && (
                                        <a href={`mailto:${contact.email}`} className='inline-block mt-3 text-xs font-medium text-blue-600 hover:text-blue-800'>
                                            Reply via Email
                                        </a>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ContactTable;
